// extracted by mini-css-extract-plugin
export var hidden = "_40-1";
export var leftPanel = "_40-2";
export var readonlyInspector = "_40-3";
export var rightPanel = "_40-0";